export const customEventName = 'event-analytics'
